<div class="headerrow row space-between">
    <div class="col gap-8">
        <h1 i18n routerLink="/home/user/poc">
            Welcome<span *ngIf="userData?.prename"
                >, {{ userData?.prename }}!</span
            >
            👋
        </h1>
        <h4 i18n>A great day to disrupt the world with your innovation!</h4>
    </div>

    <div class="rightactionbar row gap-16">
        <!-- <rr-teamheader></rr-teamheader> -->
        <!-- <rr-btn
      iconStart="settings"
      type="Secondary"
      i18n
      routerLink="/home/user"
      [queryParams]="{ settings: true, page: 1 }"
      >Settings</rr-btn
    > -->
        <rr-btn
            iconStart="add"
            type="Primary"
            i18n
            routerLink="/home/user"
            [queryParams]="{ 'new-stream': true }"
            >New Business Idea</rr-btn
        >
    </div>
</div>
<div
    class="streamarea col"
    [ngClass]="userStreams.length === 0 ? 'justify-center' : ''"
>
    <!-- Empty State -->
    @if(!userStreams.length || userStreams.length === 0){
    <div class="col gap-48 align-center justify-center align-self-center">
        <div class="col gap-24 align-center justify-center">
            <img src="/images/empty_user_streams.png" alt="" />
            <div i18n class="text-center">
                You did not create any Ideas yet. Once you begin,<br />your idea
                stream will be shown here
            </div>
        </div>
        <div class="col gap-8">
            <rr-btn
                iconStart="add"
                type="Primary"
                i18n
                routerLink="/home/user"
                [queryParams]="{ 'new-stream': true }"
                >New Business Idea</rr-btn
            >
        </div>
        <!-- <div class="row gap-8">
      <div i18n class="tiny">How to begin?</div>
      <div class="link">Take a tour</div>
    </div> -->
    </div>
    }

    <!-- If streams exist -->
    @if(userStreams && userStreams.length > 0){ @for(stack of trackDataToShow;
    track stack.tracks){
    <div class="usertreams col w100 gap-24">
        <div class="col w100 gap-8">
            <span class="uppercase-label">{{
                stack.date === today
                    ? "Today"
                    : stack.date === yesterday
                    ? "Yesterday"
                    : stack.date
            }}</span>
            <div class="col w100 groupedwrapper gap-4">
                <!-- <rr-usertrack-row
              [track]="track"
              class="streamsrow"
              *ngFor="let track of userStreams"
            ></rr-usertrack-row> -->
                <rr-detail-track-row
                    [track]="track"
                    *ngFor="let track of stack.tracks"
                ></rr-detail-track-row>
            </div>
        </div>
    </div>
    } }
</div>
